import elmntIO from './inc/elmnt-io.js';
import { globalLoaderElementSimpleStop } from './loader-element.js';

export function heroFullScreen() {
    const $heroFsComp = document.querySelector('.component--hero-fs');
    if (!$heroFsComp) return;

    const $heroFsInner = $heroFsComp.querySelector('.hero-fs__inner');
    const $loader = $heroFsComp.querySelector('.loader-element');
    const $video = $heroFsComp.querySelector('video');
    const $videoBtn = $heroFsComp.querySelector('.hero-fs__video-btn');


    // ========== page load ==========
    // we kick of the loader even if the hero isn't in the viewport

    // force top of page (no visible scroll, including back/forward)
    const forceScrollTop = () => {
        window.scrollTo(0, 0);
    };

    if ( 'scrollRestoration' in history ) {
        history.scrollRestoration = 'manual';
    }

    forceScrollTop();
    window.addEventListener('pageshow', forceScrollTop);
    window.addEventListener('pagehide', forceScrollTop);


    /// ========== media load ==========
    const minWait = new Promise((resolve) => setTimeout(resolve, 500));
    const mediaReady = new Promise((resolve) => {
        if ( !$video ) {
            resolve();
            return;
        }

        if ( $video.readyState >= 3 ) {
            resolve();
            return;
        }

        $video.addEventListener('canplay', resolve, { once: true });
    });

    Promise.all([minWait, mediaReady]).then(handleLoaded);

    function handleLoaded() {
        $heroFsComp.classList.add('loaded');
        globalLoaderElementSimpleStop($loader);

        setTimeout(() => {
            document.body.classList.remove('force-hide-header');
        }, 1500);
    }


    // ========== handle hero first enter ==========
    elmntIO($heroFsComp);

    // function handleIoEnter() {}

    



    // ========== handle video ==========
    if ( $video ) {
        // Video button click event listener
        $videoBtn?.addEventListener('click', () => {
            if ( $video.paused ) {
                $video.play();
                $videoBtn.setAttribute('aria-pressed', 'false');
            } else {
                $video.pause();
                $videoBtn.setAttribute('aria-pressed', 'true');
            }
        });

        if ( $heroFsInner ) {
            // pause video when not in viewport
            elmntIO($heroFsInner, handleVideoEnter, handleVideoExit);
        }

        function handleVideoEnter() {
            if ( $videoBtn.getAttribute('aria-pressed') == 'false' ) {
                $video.play();
            }
        }

        function handleVideoExit() {
            $video.pause();
        }
    }
}